/************************************
MODULE:         QuoteResults
WHAT IT DOES:   Sets up loader on click of reserve button
*************************************/
(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    define(['jquery'], factory);
  } else if (typeof exports === 'object') {
    module.exports = factory(require('jquery'));
  } else {
    root.returnExports = factory(root.jQuery);
  }
})(this, function ($) {
  var quoteResults = $('.js-quote-results'),
    isInited = false,
    quoteLoader = null,
    quoteReserveBtn = null;

  function init() {
    var l = quoteResults.length;
    if (!l || isInited) return;
    isInited = true;

    quoteReserveBtn = quoteResults.find('.quote-results__reservation .button');
    if (quoteReserveBtn.length !== 0) {
      quoteLoader = quoteResults.find('[data-quote-results-loader]');
      addListeners();
    }
  }

  function addListeners() {
    quoteReserveBtn.click(handleButtonPress);
  }

  function handleButtonPress() {
    quoteReserveBtn.addClass('disabled');
    quoteLoader.find('.quote-results__loader-text').addClass('show');
    quoteLoader.addClass('loading');
  }

  return { init: init };
});



/*****************
 ** WEBPACK FOOTER
 ** ./js/app/modules/app.quoteresult.js
 ** module id = 52
 ** module chunks = 24
 **/